<template>
  <div class="campaigns-detail">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-a-PaidPlacement" style="color: #fff;"></use>
      </svg>
    </breadcrumbs>
    <div class="top-button" v-if="showPay">
      <artmisads-button type="primary" :isSquare="true" @click="pay">Pay</artmisads-button>
    </div>
    <!-- Seller Information -->
    <div class="content">
      <div class="content-wrapper-top">
        <div class="content-wrapper-top-title">
          Seller Information
        </div>
      </div>
      <div class="content-wrapper-bottom">
        <div class="content-wrapper-bottom-top">
          <div class="item">
            <div class="item-title">
              Artemisads Account:
            </div>
            <div class="item-content">
              <div>
                {{ sellerInfo?.sellerName || '--' }}
              </div>
              <div>
                {{ sellerInfo?.email || '--' }}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Campaign Amount:
            </div>
            <div class="item-content">
              {{  CURRENCY_DATA_MAPPER[campaignInfo?.currency] 
              }}
              {{ campaignInfo?.amount|| '--' }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              ServiceFee:
            </div>
            <div class="item-content">
              {{  CURRENCY_DATA_MAPPER[campaignInfo?.currency] 
              }}
              {{ campaignInfo?.platformFee|| '--' }}
            </div>
          </div>
        </div>
      </div>
      <div class="content-wrapper-bottom">
        <div class="content-wrapper-bottom-top">
          <div class="item">
            <div class="item-title">
              Amount:
            </div>
            <div class="item-content">
              {{  CURRENCY_DATA_MAPPER[campaignInfo.currency] 
              }}
              {{ campaignInfo?.amount+campaignInfo?.platformFee|| '--' }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              BD:
            </div>
            <div class="item-content">
              {{ sellerInfo?.bd || '--' }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Referral:
            </div>
            <div class="item-content">
              {{ sellerInfo?.referral || '--' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  Publisher information Information -->
    <div class="content marigin-top-16">
      <div class="content-wrapper-top">
        <div class="content-wrapper-top-title">
          Publisher Information
        </div>
      </div>
      <div class="content-wrapper-bottom">
        <div class="content-wrapper-bottom-top">
          <div class="item">
            <div class="item-title">
              Publisher Name:
            </div>
            <div class="item-content">
              {{ publisherInfo?.creatorName || '--' }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Register Email:
            </div>
            <div class="item-content">
              {{ publisherInfo?.registerEmail || '--' }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Pending Amount:
            </div>
            <div class="item-content">
              {{  CURRENCY_DATA_MAPPER[campaignInfo?.currency] 
              }}
             {{ setPendingAmount() }}
            </div>
          </div>

        </div>
      </div>
      <div class="content-wrapper-bottom">
        <div class="content-wrapper-bottom-top">
          <div class="item">
            <div class="item-title">
              BD:
            </div>
            <div class="item-content">
              {{ publisherInfo?.bd || '--' }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Referral:
            </div>
            <div class="item-content">
              {{ publisherInfo?.referral || '--' }}
            </div>
          </div>
          <div class="item">

          </div>
        </div>
      </div>
      <div class="content-wrapper-bottom">
        <div class="content-wrapper-bottom-top">
          <div class="item">
            <div class="item-title">
              Bank info:
            </div>
            <div class="item-content">
              <div>Bank Name:{{ publisherInfo?.bankInformation?.bankName || '--' }}</div>
              <div>Bank Location Country:{{ publisherInfo?.bankInformation?.bankCountry || '--' }}</div>
              <div>Account Beneficiary Name:{{ publisherInfo?.bankInformation?.bankAccountName || '--' }}</div>
              <div>Bank Account Number:{{ publisherInfo?.bankInformation?.bankAccountNumber || '--' }}</div>
              <div>Bank Account Routing Number:{{ publisherInfo?.bankInformation?.bankRountingNumber || '--' }}</div>
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Finance Review Status:
            </div>
            <div class="item-content">
              <PlacementStatus :type="publisherInfo?.bankInformation?.bankInformationReviewStatus || '--'"
              :text="publisherInfo?.bankInformation?.bankInformationReviewStatus|| '--'" />
            </div>
          </div>
        </div>
      </div>
      <div class="content-wrapper-bottom">
        <div class="content-wrapper-bottom-top">
          <div class="item">
            <div class="item-title">
              Tax info:
            </div>
            <div class="item-content">
             <div> W8ben From:{{ publisherInfo?.bankInformation?.w8beanFrom || '--' }}</div>
             <div> W9:{{  publisherInfo?.bankInformation?.w9benFrom || '--' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content marigin-top-16" v-if="campaignInfo?.status === 'Paid'">
      <div class="content-wrapper-top">
        <div class="content-wrapper-top-title">
          Payment Information
        </div>
      </div>
      <div class="content-wrapper-bottom" >
        <div class="content-wrapper-bottom-top">
          <div class="item">
            <div class="item-title">
              Paid Amount:
            </div>
            <div class="item-content">
              {{  CURRENCY_DATA_MAPPER[campaignInfo?.currency] 
              }}
              {{ campaignInfo?.operationPaymentAmount || '--' }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              PaymentDate:
            </div>
            <div class="item-content">
              {{ setTime(campaignInfo?.operationPaymentDate) }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Operator:
            </div>
            <div class="item-content">
             {{ adminUserInfo?.name || '--' }}
            </div>
          </div>

        </div>
      </div>
    </div>
      <div class="content marigin-top-16" >
      <div class="content-wrapper-top">
        <div class="content-wrapper-top-title">
          Oreder Information
        </div>
      </div>
      <div class="content-wrapper-bottom" >
        <div class="content-wrapper-bottom-top">
          <div class="item">
            <div class="item-title">
              seller申请时间:
            </div>
            <div class="item-content">
               {{ setTime(orderInfo?.sellerApplyTime) }}
              <!-- {{  CURRENCY_DATA_MAPPER[campaignInfo?.currency] 
              }}
              {{ campaignInfo?.operationPaymentAmount || '--' }} -->
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Publisher接受/拒绝时间:
            </div>
            <div class="item-content">
              {{ setTime(orderInfo?.publisherResponseTime) }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              Seller支付时间:
            </div>
            <div class="item-content">
              {{ setTime(orderInfo?.sellerPayTime) }}
            </div>
          </div>

        </div>
      </div>
    </div>
    <PayModel ref="payModel" @submit="paySubmit" />
  </div>
</template>
<script setup>
import { useRoute } from 'vue-router'

import breadcrumbs from '@/components/breadcrumbs.vue'
import { ref, onMounted } from 'vue'
import { financeApi } from "~/server/operator/finance"
import PlacementStatus from '@/components/placementStatus.vue'
import { statusInfo,CURRENCY_DATA_MAPPER } from '@/contants/common'
import PayModel from './components/payModel.vue'
import moment from 'moment'
import { useUserInfoStore } from '@/storeData'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'
const user = useUserInfoStore()
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode||'US']

const payModel = ref(null)
const route = useRoute()
const campaignId = ref(route.params.id)
const sellerInfo = ref({})
const publisherInfo = ref({})
const campaignInfo = ref({})
const orderInfo = ref({})
const adminUserInfo = ref({})
const showPay=ref(false)
const breadcrumbsData = {
  title: "Campaign Details",
  des: "Track your campaign status",
  color: '#80C026',
  links: [
    {
      name: "Home",
      path: "/operator/users",
    },
    {
      name: "Paid Placement",
      path: "/operator/paidPlacement/campaigns",
    },
    {
      name: "Campaign Details",
      path: `/operator/paidPlacement/campaigns/${campaignId.value}`,
    },
  ],
}
const init = () => {
  financeApi.campaignsDetail({ campaignId: campaignId.value }).then(res => {
   
    showPay.value = res.displayPay
    sellerInfo.value = res.sellerVO
    publisherInfo.value = res.adminPublisherVO
    campaignInfo.value=res.campaignInfo
    adminUserInfo.value=res.adminUserVO
    orderInfo.value=res.orderInfo
  })
}
const setTime = (time) => {
  if(time){

    return moment(time).tz(timezone).format('YYYY-MM-DD HH:mm:ss')
  }
  else{
    return ''
  }
}
const setPendingAmount = () => {
  if(campaignInfo.value?.operationPaymentAmount){
    return campaignInfo.value?.amount-campaignInfo.value?.operationPaymentAmount
  }
  else{
    return campaignInfo.value?.amount
  }
}
const paySubmit = () => {
  init()
}
const pay = () => {
  payModel.value.open(campaignId.value)
}
onMounted(() => {
  const { id } = route.params
  if (id) {
    campaignId.value = id
  }
  init()
})
</script>
<style lang="less" scoped>
.marigin-top-16 {
  margin-top: 16px;
}

.campaigns-detail {
  padding: 16px;
  padding-top: unset;
  width: 100%;
  position: relative;
  .top-button{
    position: absolute;
    top: 32px;
    right: 16px;
  }
}

.content {
  border-radius: 8px;
  background-color: #fff;

  .content-wrapper-bottom {
    padding: 24px 16px;
  }

  .content-wrapper-top {
    border-bottom: 1px solid #E5E6EB;

    .content-wrapper-top-title-button {
      display: flex;
      justify-content: space-between;
      align-items: center;

    }

    .content-wrapper-top-title {
      font-family: Sora;
      font-weight: 600;
      font-size: 20px;
      padding: 16px;
    }
  }

  .steps-wrapper {
    padding: 16px 20px;
  }

  .content-wrapper-bottom-top {
    display: flex;

    // padding: 16px;
    .content-wrapper-bottom-top-item {
      background: #F1F0F5;
      padding: 10px 12px;
      display: flex;
      border-radius: 8px;
      flex: 1;
      gap: 16px;

      .content-wrapper-bottom-top-item-title {
        color: #0f062980;
        font-family: "Sora";
        font-size: 13px;
        font-style: normal;
        font-weight: 500;

        opacity: 0.7;
      }

      .content-wrapper-bottom-top-item-content {
        color: #0f0629e6;
        font-family: "Sora";
        font-size: 18px;
        font-style: normal;
        font-weight: 600;

      }

      .content-wrapper-bottom-top-item-left {
        flex: 1;

      }

    }

    .item {
      flex: 1;

      .item-title {
        font-family: Sora;
        font-weight: 400;
        font-size: 13px;
        color: #0f0629;
        opacity: 0.5;
      }

      .item-content {
        font-family: Sora;
        font-weight: 500;
        font-style: Medium;
        font-size: 14px;
        margin-top: 4px;

        .resources-content {
          display: flex;
          gap: 10px;
        }

      }
    }
  }
}
</style>